import React, { Component } from "react";

// Form Editor

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { FormLabel } from "@mui/material";
import { Alignment, Bold, ClassicEditor, Essentials, FontBackgroundColor, FontColor, FontFamily, FontSize, HorizontalLine, Italic, Link, List, MediaEmbed, Mention, Paragraph, Table, Underline, Undo } from "ckeditor5";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import 'ckeditor5/ckeditor5.css';

class FormEditors extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render() {
    return (
      <React.Fragment>
        <FormLabel style={{fontFamily: 'Manrope-SemiBold', fontSize: 14}}>{this.props?.title}</FormLabel>
        <CKEditor
          editor={ClassicEditor}
          data={this.props?.value}
          onChange={(event, editor) => { this.props?.setValue(editor.getData()) }}
          config={{
            toolbar: {
              items: [
                'fontFamily',
                'bold',
                'italic',
                'underline',
                'fontSize',
                'fontColor',
                'fontBackgroundColor',
                'bulletedList',
                'numberedList',
                'alignment',
                'link',
                'insertTable',
                'horizontalLine',
                'undo',
                'redo', '|',
              ],
            },
            placeholder: this.props?.placeholder || "",
            plugins: [
              Bold,
              Essentials,
              Italic,
              Mention,
              Paragraph,
              Undo,
              FontFamily,
              FontSize,
              FontColor,
              FontBackgroundColor,
              Underline,
              List,
              Alignment,
              HorizontalLine,
              Link,
              Table
            ],
            // toolbar: {
            //   items: [
            //     'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor',
            //     '|',
            //     'bold', 'italic', 'strikethrough', 'subscript', 'superscript', 'code',
            //     '|',
            //     'link', 'uploadImage', 'blockQuote', 'codeBlock',
            //     '|',
            //     'bulletedList', 'numberedList', 'todoList', 'outdent', 'indent',
            //     '|',
            //     'alignment',
            //     '|',
            //     'undo', 'redo',
            //     '|',
            // ],
            // },

          }}
          onReady={(editor) => {
            // You can store the "editor" and use when it is needed.
          }}
        />
      </React.Fragment>
    );
  };
};

export default FormEditors;
